import { Component, OnInit } from '@angular/core';
import { FormBuildComponent } from '../form-build/form-build.component';
import { FormBuildService } from '../../service/form-build.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-form-wizard',
  templateUrl: './form-wizard.component.html',
  styleUrls: ['./form-wizard.component.scss']
})
export class FormWizardComponent extends FormBuildComponent implements OnInit {

  step = 0;
  current: any = {};
  list: any[] = [];


  isLeftBarExpand = false;

  constructor(public formBuildService: FormBuildService) {
    super(formBuildService);
  }

  ngOnInit() {
    this.form = new FormGroup({});
    this.list.push({ title: 'Ingresar al Sistema', template: 'commerce-login' });
    this.list.push({ title: 'Datos generales de tu negocio y su ubicación', template: 'commerce-general' });
    this.list.push({ title: 'Finanzas', template: 'commerce-finances' });
    this.list.push({ title: 'Enlaces electrónicos de verificación', template: 'commerce-verification' });
    this.setCurrent();
  }

  setCurrent() {
    this.current = this.list[this.step];
  }

  prev() {
    this.step = this.step === 0 ? 0 : this.step - 1;
    this.setCurrent();
  }
  next() {
    this.step = this.step === this.list.length - 1 ? this.list.length - 1 : this.step + 1;
    this.setCurrent();
  }

  end() {
    //console.log(this.form.value);
  }

  canPrev() {
    return this.step > 0;
  }
  canNext() {
    return this.step < this.list.length - 1;
  }

  isFinalStep() {
    return this.step === this.list.length - 1;
  }

}



// WEBPACK FOOTER //
// ./src/app/form/core/component/form-wizard/form-wizard.component.ts